import React, { useEffect } from "react";
import { LandingPage } from "./components/LandingPage";
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
  }
}
type MetaPixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  loaded?: boolean;
  version?: string;
};
const META_PIXEL_ID = "1636040964726895";
export function App() {
  useEffect(() => {
    if (window.fbq) return;
    const fbq: MetaPixelFunction = (...args) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue?.push(args);
      }
    };
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = "2.0";
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
    fbq("init", META_PIXEL_ID);
    fbq("track", "PageView");
  }, []);
  return <LandingPage data-id="element-0" data-mp="3iiweam7rne26" />;
}